import React from "react";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const Testemonials = () => {
  const { t } = useTranslation();

  const TestemonialsList = [
    {
      text: t("testimonial.first.text"),
      name: t("testimonial.first.name"),
      position: t("testimonial.first.position")
    },
    {
      text: t("testimonial.second.text"),
      name: t("testimonial.second.name"),
      position: t("testimonial.second.position")
    },
  ]

  return (
      <div className="rn-testimonial-area pt--120 bg_color--5" id="testimonial">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center service-style--3 mb--30 pb--30">
                <h2 className="title">{t("testimonial.title")}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <React.Fragment>
            <div className="row">
              <div className="col-lg-12">
                <Tabs>
                  {TestemonialsList.map( (testemonial , i) => (
                      <TabPanel>
                        <div className="rn-testimonial-content text-center">
                          <div className="inner">
                            <p>{ testemonial.text }</p>
                          </div>
                          <div className="author-info">
                            <h6><span>{ testemonial.name } </span> - { testemonial.position }</h6>
                          </div>
                        </div>
                      </TabPanel>
                  ))}

                  <TabList className="testimonial-thumb-wrapper">
                    <Tab>
                      <div className="testimonial-thumbnai">
                        <div className="thumb">
                          <img src="/assets/images/client/male.svg" alt="Testimonial Images"/>
                        </div>
                      </div>
                    </Tab>
                    <Tab>
                      <div className="testimonial-thumbnai">
                        <div className="thumb">
                          <img src="/assets/images/client/female.svg" alt="Testimonial Images"/>
                        </div>
                      </div>
                    </Tab>
                  </TabList>
                </Tabs>
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
  );
}

export default Testemonials;
